import React, { Component } from 'react';
import { Localization } from '../localization/index';
import { Colors } from '../colors/index';

import Modal from 'react-modal'
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



class CustomerLoyalty extends Component {

    state = {
        isLoading: false,
        customer: null,
        phone: undefined,

    }


    getCustomerInfo = () => {

        this.setState({ isLoading: true })


        fetch('https://pnl.api.paklean.com/puser/customer/loyality/info/' + this.state.phone, {
            method: 'GET',
            headers: {
                Authorization: global.authorization,
                'Content-Type': 'application/json'
            },

        }).then(response => response.json())
            .then((responseJson) => {
                if (responseJson.data) {
                    this.setState({
                        isLoading: false,
                        customer: responseJson.data
                    });

                } else {
                    this.setState({ isLoading: false }, () => {
                        toast(Localization.Farsi.error)
                    });
                }
            }).catch((err) => {
                this.setState({ isLoading: false, });
            })
    }



    render() {
        const {customer} = this.state
        
        return (
            <div style={styles.container}>

                <div style={styles.content}>


                    <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', }} >
                        <div style={{flex: 1,  display: 'flex', flexDirection: 'row-reverse', marginTop: 30, paddingTop: 5, alignItems: 'center' }} >

                                <p >{Localization.Farsi.phoneNumber}: </p>
                                <form  onSubmit={ (e) => {
                                    e.preventDefault()
                                    this.getCustomerInfo()
                                }}>
                                <input
                                    type='number'
                                    style={{ textAlign: 'center', marginLeft: 15, marginRight: 15 }}
                                    onChange={(e) => { this.setState({ phone: e.target.value }) }}
                                />
                                </form>

                                <button style={{ alignSelf: 'center', width: 150, backgroundColor: 'green', padding: 5, color: 'white', border: '1px solid green', borderRadius: 5 }}
                                    onClick={this.getCustomerInfo} >
                                    مشاهده
                                
                                </button>
                        </div>




                        {this.state.customer ?
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', flex:1 ,marginTop:30 }} >

                            <p style={styles.text} >{Localization.Farsi.timePassedFromRegisteration}: {customer.nowFromRegister} روز</p>
                            <p style={styles.text} >{Localization.Farsi.firstOrderDate}: {customer.firstOrderDate}</p>
                            <p style={styles.text} >{Localization.Farsi.timePassedFromFirstOrderToRegister}: {customer.firstOrderFromRegister} روز</p>
                            <p style={styles.text} >{Localization.Farsi.lastOrderDate}: {customer.lastOrderDate}</p>
                            <p style={styles.text} >{Localization.Farsi.timePassedFromLastOrder}: {customer.fromLastOrder} روز</p>

                            <p style={styles.text} >{Localization.Farsi.orderFrequency}: {customer.frq} روز</p>
                            <p style={styles.text} >{Localization.Farsi.orderCount}: {customer.orderCount}</p>
                            <p style={styles.text} >{Localization.Farsi.totalItems}: {customer.totalItems}</p>
                            <p style={styles.text} >{Localization.Farsi.totalCart}: {customer.totalVal} تومان</p>
                            <p style={styles.text} >{Localization.Farsi.totalDiscount}: {customer.totalDiscount} تومان</p>
                            <p style={styles.text} >{Localization.Farsi.totalRevenue}: {customer.rev} تومان</p>


                            </div>

                        :
                        null
                    }

                    </div>



                </div>


                <ToastContainer
                    closeButton={false}
                    hideProgressBar
                    rtl
                    style={{ textAlign: 'center', color: 'black', }}
                    autoClose={2000}
                    pauseOnFocusLoss={false}
                    position="bottom-center" />


                <Modal
                    isOpen={this.state.isLoading}
                    style={styles.spinnerStyle} >
                    <div style={{
                        display: 'flex', justifyContent: 'center',
                        WebkitBoxPack: 'center', WebkitBoxPack: 'center', WebkitBoxAlign: 'center', alignItems: 'center', WebkitBoxAlign: 'center',
                    }}>
                        <ClipLoader
                            size={100}
                            color={Colors.SpinnerColor}
                            loading={this.state.isLoading}
                        />
                    </div>

                </Modal>

            </div>

        )
    }


}



export default CustomerLoyalty

const styles = {

    modalStyles: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
        },
    },

    modalStylesNotComplete: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.85)",
        },
    }
    ,
    spinnerStyle: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            border: 'none',
            outline: 'none',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'transparent'
        },
        overlay: {
            zIndex: 10,
        },
    },

    content: {

        position: 'fixed',
        padding: 10,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignSelf: 'center',
        WebkitBoxOrient: 'vertical', flexDirection: 'column',
        alignItems: 'center', WebkitBoxAlign: 'center',
    },

    container: {

        display: '-webkit-box',
        display: '-moz-box',
        display: '-ms-flexbox',
        display: '-webkit-flex',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 'auto',
        justifyContent: 'stretch',
        alignItems: 'flex-start',
        WebkitBoxOrient: 'vertical',
        WebkitBoxDirection: 'normal',
        WebkitFlexDirection: 'column',
        WebkitFlexGrow: 1,
        WebkitFlexShrink: 0,
        WebkitFlexBasis: 'auto',
        WebkitBoxPack: 'stretch',
        WebkitJustifyContent: 'stretch',
        WebkitBoxAlign: 'start',
        WebkitAlignItems: 'flex-start',

    },

    text:{
        flex:1,
        paddingTop:5,
        paddingBottom:5,
        borderBottom:'solid',
        borderBottomWidth:1,
        borderBottomColor:Colors.GreenActiveButton,
    }
};